import React, { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../../config";
import "./emailInbox.css";

export default function EmailInbox() {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEmails = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/auth/emails/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
        },
      });
      setEmails(response.data);
    } catch (error) {
      console.error("Error fetching emails:", error);
      alert("Failed to load emails. Please connect Gmail first.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmails();
  }, []);

  const connectGmail = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/auth/google/init/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
        },
      });
      window.location.href = res.data.auth_url;
    } catch (error) {
      console.error("Error connecting Gmail:", error);
      alert("Failed to initiate Gmail connection.");
    }
  };

  return (
    <div className="inbox-wrapper-unique">
      <div className="inbox-header-unique">
        <h2 className="inbox-title-unique">📨 Email Inbox</h2>
        <div className="inbox-actions-unique">
          <button
            className="inbox-btn-unique inbox-btn-connect-unique"
            onClick={connectGmail}
          >
            Connect Gmail
          </button>
          <button
            className="inbox-btn-unique inbox-btn-refresh-unique"
            onClick={fetchEmails}
            disabled={loading}
          >
            Refresh
          </button>
        </div>
      </div>

      <div className="inbox-content-unique">
        {loading ? (
          <p className="inbox-message-unique">⏳ Loading emails...</p>
        ) : emails.length === 0 ? (
          <p className="inbox-message-unique">
            No emails found. Try connecting Gmail.
          </p>
        ) : (
          <ul className="inbox-list-unique">
            {emails.map((email, index) => (
              <li key={index} className="inbox-item-unique">
                <div className="inbox-item-header-unique">
                  <span className="inbox-from-unique">{email.from}</span>
                  <span className="inbox-subject-unique">{email.subject}</span>
                </div>
                <p className="inbox-snippet-unique">{email.snippet}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
